var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_split_pane_1 = require("react-split-pane");
var PaneHeader_1 = require("./PaneHeader");
var EmptyPane_1 = require("./EmptyPane");
var Pane_styled_1 = require("./Pane_styled");
var Pane = /** @class */ (function (_super) {
    __extends(Pane, _super);
    function Pane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setCurrentPane = function () {
            var _a = _this.props, pane = _a.pane, setCurrentPane = _a.setCurrentPane;
            setCurrentPane(pane.id);
        };
        _this.setCurrentContent = function (contentId) {
            var _a = _this.props, pane = _a.pane, setPaneCurrentContent = _a.setPaneCurrentContent;
            setPaneCurrentContent(pane.id, contentId);
        };
        _this.removeContent = function (contentId) {
            var _a = _this.props, pane = _a.pane, removePaneContent = _a.removePaneContent;
            removePaneContent(pane.id, contentId);
        };
        _this.closeContent = function (contentId) { return function () {
            _this.removeContent(contentId);
        }; };
        _this.splitPane = function (axis) {
            var _a = _this.props, pane = _a.pane, splitPane = _a.splitPane;
            splitPane(pane.id, axis);
        };
        return _this;
    }
    Pane.prototype.render = function () {
        var _a = this.props, pane = _a.pane, panes = _a.panes, contentTypes = _a.contentTypes, setCurrentPane = _a.setCurrentPane, setPaneCurrentContent = _a.setPaneCurrentContent, removePaneContent = _a.removePaneContent, splitPane = _a.splitPane;
        if (pane.split === true) {
            return (React.createElement(react_split_pane_1.default, { split: pane.splitAxis, defaultSize: "50%" }, pane.children.map(function (childPaneId) {
                var childPane = panes.find(function (p) { return p.id === childPaneId; });
                if (childPane === undefined) {
                    throw new Error("no pane found for id: " + childPaneId + "\n" + JSON.stringify(pane));
                }
                return (React.createElement(Pane, { key: childPaneId, pane: childPane, panes: panes, contentTypes: contentTypes, setCurrentPane: setCurrentPane, setPaneCurrentContent: setPaneCurrentContent, removePaneContent: removePaneContent, splitPane: splitPane }));
            })));
        }
        var contents = [];
        var content;
        if (pane !== undefined) {
            contents = pane.contents;
            content = contents.find(function (c) { return c.isCurrent; });
        }
        if (content === undefined)
            return React.createElement(EmptyPane_1.default, null);
        var foundContent = content;
        var contentType = contentTypes.find(function (ct) { return ct.id === foundContent.type; });
        if (contentType === undefined) {
            throw new Error("unsupported content type: " + foundContent.type + "\n" + JSON.stringify(foundContent));
        }
        return (React.createElement(Pane_styled_1.Container, { isCurrent: pane.isCurrent, onClick: this.setCurrentPane },
            React.createElement(PaneHeader_1.default, { contentTypes: contentTypes, pane: pane, setCurrentContent: this.setCurrentContent, removeContent: this.removeContent, splitPane: this.splitPane }),
            React.createElement(Pane_styled_1.Content, null, contentType.renderPane({
                content: foundContent,
                pane: pane,
                extra: {
                    close: this.closeContent(content.id)
                }
            }))));
    };
    return Pane;
}(React.Component));
exports.default = Pane;
